import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, TransitionGroup as _TransitionGroup, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  class: "mall-toast-host",
  "aria-live": "polite",
  "aria-relevant": "additions"
}
const _hoisted_2 = ["onClick"]

import AppIcon from '@/components/common/AppIcon.vue'
import { useMallToast, type MallToastTone } from '@/composables/useMallToast'


export default /*@__PURE__*/_defineComponent({
  __name: 'MallToastHost',
  setup(__props) {

const { toasts, dismissToast } = useMallToast()

function toneIcon(tone: MallToastTone) {
  if (tone === 'success') return 'mdi-check-circle-outline'
  if (tone === 'error') return 'mdi-alert-circle-outline'
  return 'mdi-information-outline'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_TransitionGroup, { name: "mall-toast" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(toasts), (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item.id,
            class: _normalizeClass(["mall-toast", `is-${item.tone}`]),
            role: "status"
          }, [
            _createVNode(AppIcon, {
              icon: toneIcon(item.tone),
              size: 18
            }, null, 8, ["icon"]),
            _createElementVNode("p", null, _toDisplayString(item.message), 1),
            _createElementVNode("button", {
              type: "button",
              "aria-label": "닫기",
              onClick: ($event: any) => (_unref(dismissToast)(item.id))
            }, [
              _createVNode(AppIcon, {
                icon: "mdi-close",
                size: 16
              })
            ], 8, _hoisted_2)
          ], 2))
        }), 128))
      ]),
      _: 1
    })
  ]))
}
}

})